import { render, staticRenderFns } from "./ArchiveProcessModal.vue?vue&type=template&id=f184efb6&scoped=true&"
import script from "./ArchiveProcessModal.vue?vue&type=script&lang=js&"
export * from "./ArchiveProcessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f184efb6",
  null
  
)

export default component.exports